import styled from 'styled-components';
import { Menu as AntdMenu, Button } from 'antd';
import { Color } from '@bb/elements-web';
import Layout from '../Layout';
import Icon from '../Icon';
import logo from '../../img/logo_v2.svg';
import supraLogo from '../../img/supraLogo.svg';
import supraLogoMini from '../../img/supraLogoMini.svg';
import theme from '../theme';

export const StyledContainer = styled.div<{
  $siderCurrentWidth: number;
  $transition: number;
}>`
  width: ${({ $siderCurrentWidth }) => `${$siderCurrentWidth}px`};
  transition: ${({ $transition }) => `all ${$transition}s`};
`;

export const StyledSider = styled(Layout.Sider)<{
  collapsed: boolean;
  $offsetTop: number;
  $isMobile: boolean;
}>`
  && {
    border-right: 0;
    margin-top: ${({ $offsetTop }) => `${$offsetTop}px`};
    height: ${({ $offsetTop }) => `calc(100vh - ${$offsetTop}px)`};

    position: fixed;
    z-index: 200;

    .ant-layout-sider-children {
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      ${({ $isMobile }) => $isMobile && `padding-bottom: 6em;`}
    }

    .sider-content {
      height: 100%;
      display: grid;
      grid-template-rows: 66px auto 1fr;
    }

    .brokerbay-logo {
      width: ${({ collapsed }) => (collapsed ? '75%' : '100%')};
      padding: 32px;
      background-image: url(${logo});
      background-size: 150px;
      background-repeat: no-repeat;
      background-position: ${({ collapsed }) =>
        collapsed ? '-30% 50%' : '50%'};
      transition: all 0.2s;
    }
  }
`;

export const StyledMenu = styled(AntdMenu)`
  && {
    background: transparent;
    overflow-x: hidden;
  }
  // if there are more than 4 submenu items list should scroll
  .ant-menu-sub {
    max-height: 192px;
    overflow-x: hidden;
    overflow-y: auto;
  }
  // If a sub-menu is open but no item is selected, the title should remain grey
  .ant-menu-submenu-open > .ant-menu-submenu-title {
    color: ${theme.gray7};
  }

  .ant-menu-item-selected > .ant-menu-title-content,
  .ant-menu-item-selected > .ant-menu-title-content a,
  .ant-menu-item-active :hover,
  .ant-menu-submenu-title :hover {
    color: ${Color.PRIMARY};
  }
`;

export const StyledOrgLogoWrapper = styled.div<{
  collapsed: boolean;
  hasLinkAccountsFeature?: boolean;
}>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s;
  > .org-logo-circle {
    height: ${({ collapsed, hasLinkAccountsFeature }) =>
      collapsed ? '50px' : hasLinkAccountsFeature ? '120px' : '160px'};
    width: ${({ collapsed, hasLinkAccountsFeature }) =>
      collapsed ? '50px' : hasLinkAccountsFeature ? '120px' : '160px'};
    overflow: hidden;
    border-radius: 50%;
    box-shadow: ${theme.getElevation()};
    background: white;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      padding: ${({ collapsed }) => (collapsed ? '0' : '10px')};
      transition: all 0.2s;
    }
    > a {
      width: 100%;
      height: 100%;
      .add-logo-btn {
        width: 100%;
        height: 100%;
        border: none;
        box-shadow: none;
        .btn-text {
          display: ${({ collapsed }) => (collapsed ? 'none' : 'inline-block')};
        }
      }
    }
  }
`;

export const StyledAdminQueueItem = styled(AntdMenu.Item)<{
  $siderCollapsed?: boolean;
}>`
  .admin-queue-text {
    ${({ $siderCollapsed }) => $siderCollapsed && `opacity: 0;`}
    transition: opacity 0.2s;
  }

  &&& .ant-menu-title-content {
    overflow: visible;
  }

  ${({ $siderCollapsed }) => `
  ${
    !$siderCollapsed &&
    `
    a {
      display: inline-flex;
      justify-content: space-between;
      width: 150px;
      align-items: center;
    }
  `
  }
`}
`;

export const StyledTrigger = styled(AntdMenu)<{
  $collapsed: boolean;
  $isMobile: boolean;
}>`
  && {
    background: transparent;
    ${({ $isMobile }) => $isMobile && `display: none;`}
    ${Icon} {
      transform: ${({ $collapsed }) =>
        $collapsed ? 'scaleX(-1)' : 'scaleX(1)'};
      transition: transform 0.2s;
    }
    &:hover span,
    span {
      color: ${theme.textColorSecondary};
    }
  }
`;

export const MenuItemContainer = styled.div`
  display: inline-flex;
  justify-content: space-between;
  width: 150px;
  align-items: center;
`;

export const StyledLogoButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    // color: #000;
    background: #f2f5f0;
    border-radius: 50%;
    border-color: #fff;
    path:nth-of-type(2n) {
      color: #f2f5f0;
    }
  }
`;

export const SupraLogo = styled.div<{
  collapsed?: boolean;
  $logoWidth?: string;
}>`
  width: 100%;
  padding: 32px;
  margin-top: 16px;
  background-image: url(${({ collapsed }) =>
    collapsed ? supraLogoMini : supraLogo});
  background-size: ${({ collapsed, $logoWidth }) =>
    collapsed ? '60px' : $logoWidth || '150px'};
  background-repeat: no-repeat;
  background-position: ${({ collapsed }) => (collapsed ? '50%' : '50%')};
  transition: all 0.2s;
`;

export const StyledShowingIcon = styled(Icon)`
  width: 18px;
`;
